<div class="container-fluid ps-0">

    <div class="validation-container">
        <rask-virkeskop-validation-message
            entityType="skogsvardsatgarddetaljer"
            [entityGuid]="skogsvardsAtgard.guid">
        </rask-virkeskop-validation-message>
    </div>
    <div class="row">
        <div class="col-4">
            <rask-simple-selector
                #planeringsstatusSelector
                label="Status i Rask"
                (ngModelChange)="onPlaneringsstatusChange(planeringsstatusSelector.value)"
                [values]="atgardPlaneringsstatusLista"
                bindLabel="value"
                bindValue="value"
                [clearable]="false"
                [(ngModel)]="skogsvardsAtgard.status"
                [disabled]="statusDisabled()"
                class="w-100">
            </rask-simple-selector>
        </div>
        <div class="col-4">
            @if (skogsvardsAtgard.skogsvardStatus) {
            <rask-textmultiline
                aid="skogsvardstatus"
                label="Status i SVP"
                class="min-width-skogsvardstatus">
                <div>
                    <div>
                        {{skogsvardsAtgard.skogsvardStatus}}
                        @if (skogsvardsAtgard.skogsvardOnskatDatum) {
                        <span>, önsk. dat:
                            {{getSkogsvardOnskatdatum()}}</span>
                        }
                    </div>
                    <div class="statushandelsedatum">
                        Status hämtad: {{getSkogsvardStatusHandelsedatum()}}
                    </div>
                </div>
            </rask-textmultiline>
            }
        </div>
        <div class="col-4 slutjusterad-column">
            @if (canRemoveAtgard()) {
            <rask-button
                aid="buttonTaBortAtgard"
                color="secondary"
                (click)="onRemoveAtgard()"
                negative>
                Ta bort
            </rask-button>
            }
            @if (skogsvardsAtgard.slutjusteradDatum) {
            <rask-textmultiline
                aid="slutjusteradstatus"
                label="Slutjusterad"
                class="min-width-skogsvardstatus">
                <div>
                    <span>{{getSlutjusteraddatum()}}
                         @if (lasUppvisible()) {
                            <rask-icon-button aid="undoSlutjustera" (click)="onLasUpp()" icon="fas fa-undo" ngbTooltip="Ångra slutjustera" placement="bottom"></rask-icon-button>
                         }
                    </span>
                </div>
            </rask-textmultiline>
            } @else if(isNotSkogsvardFPVKontrakt()) {
            <rask-button
                aid="slutjusterAtgard"
                color="secondary"
                (click)="onSlutjustera()"
                [disabled]="slutjusteraDisabled()">
                Slutjustera
            </rask-button>
            }
        </div>
    </div>

    <div class="row">
        <div class="col-4">
            @if (skogsvardTyper?.length > 0) {
            <rask-simple-selector
                label="Typ"
                [values]="skogsvardTyper"
                [ngModel]="skogsvardsAtgard.atgardstyp"
                (ngModelChange)="onSkogsvardTyperChanged($event)"
                [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
                class="w-100">
            </rask-simple-selector>
            }
            @if (isPlantleverans()) {
            <rask-textmultiline
                label="Typ"
                value="Plantleverans">
            </rask-textmultiline>
            }
        </div>
        <div class="col-4">
            @if (skogsvardMetoder?.length > 0) {
            <rask-simple-selector
                label="Metod"
                [values]="skogsvardMetoder"
                [(ngModel)]="skogsvardsAtgard.atgardsmetod"
                (ngModelChange)="onDetaljerChanged()"
                [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
                class="w-100"
                [clearable]="true">
            </rask-simple-selector>
            }
        </div>
        <div class="col-4">
            <rask-datepicker
                #onskatDatum
                label="Önskat datum"
                [onlyMonths]="true"
                [allowInvalidInput]="false"
                [minDate]="minSelectableDate"
                [ngModel]="getOnskatdatum()"
                (ngModelChange)="onOnskatDatumChange(onskatDatum.value)"
                [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly">
            </rask-datepicker>

        </div>
    </div>

    @if (isMarkberedning()) {
    <rask-skogsvard-detaljer-mb></rask-skogsvard-detaljer-mb>
    }

    @if (isForyngring()) {
    <rask-skogsvard-detaljer-for></rask-skogsvard-detaljer-for>
    }

    @if (isRojning()) {
    <rask-skogsvard-detaljer-rojning></rask-skogsvard-detaljer-rojning>
    }

    <div class="row">
        <div class="col-4">
            <rask-simple-selector
                [disabled]="skogsvardsAtgard.isReadonly"
                class="w-100"
                label="Målklass"
                [values]="malKlasser"
                (ngModelChange)="onDetaljerChanged()"
                [(ngModel)]="skogsvardsAtgard.malklass">
            </rask-simple-selector>
        </div>
        <div class="col-4">
            <rask-input
                [disabled]="skogsvardsAtgard.isReadonly"
                class="w-100"
                label="Extern beteckning"
                aid="skogsvardExternBeteckning"
                [(ngModel)]="skogsvardsAtgard.externBeteckning"
                [infoText]="externBeteckningInfotext"
                [maxlength]="30"
                (ngModelChange)="onDetaljerChanged()">
            </rask-input>
        </div>
    </div>

    <div class="row">
        @if (isPlantleverans()) {
        <div class="col-12">

            <rask-textarea
                #anteckningarPlantleverans
                label="Ange utlämningsplats"
                class="w-100 mt-5 mb-4"
                [(ngModel)]="skogsvardsAtgard.anteckningSkogsvard"
                [disabled]="skogsvardsAtgard.isReadonly"
                [maxlength]="2000"
                [rows]="3"
                aid="anteckningAO"
                (ngModelChange)="onDetaljerChanged()">
            </rask-textarea>
        </div>
        }
        @else{
        <rask-textarea
            #anteckningarAO
            label="Anteckningar till AO"
            ngbTooltip="Här kan du skriva info som är bra att få ut på arbetsordern, t.ex kod till bommar."
            class="col-8 pb-3"
            [(ngModel)]="skogsvardsAtgard.anteckningSkogsvard"
            [disabled]="skogsvardsAtgard.isReadonly"
            [maxlength]="2000"
            [rows]="3"
            aid="anteckningAO"
            (ngModelChange)="onDetaljerChanged()">
        </rask-textarea>
        <rask-checkbox
            class="col"
            [fillHeight]="true"
            label="Visa i utskrift"
            [disabled]="skogsvardsAtgard.isReadonly"
            [(ngModel)]="skogsvardsAtgard.visaAnteckningSkogsvardIUtskrift"
            (ngModelChange)="onDetaljerChanged()">
        </rask-checkbox>
        }
    </div>
</div>